import { App } from './app.class';
import { Notification } from './notification.class';
import { Popup } from './popup.class';
import { Fetch } from '../fetch.class';
import Upgrademodal from './upgrademodal.class';

export class Page {

    constructor() {

        // Elemente
        this.$formCode = document.querySelector('header .form_code');
        this.$submissionView = document.querySelector('#submission_view');
        this.menuActions = document.querySelectorAll('button.action');

        // Formular-Code
        this.form_code = this.$formCode.textContent;

        // Aktionen im Aktions-Menü ein- und ausblenden
        this.displayMenuActions();

        // Events: Aktions-Menü
        this.menuActions.forEach(el => {
            el.addEventListener('click', event => {

                // ID der Sendung
                const id = parseInt( this.$submissionView.dataset.id );

                // Aktionen
                if(el.classList.contains('isspam')) {
                    this.moveTo('spam', [ id ]);
                }
                else if(el.classList.contains('nospam')) {
                    this.moveTo('inbox', [ id ]);
                }
                else if(el.classList.contains('delete')) {
                    this.moveTo('trash', [ id ]);
                }
                else if(el.classList.contains('undelete')) {
                    this.moveTo('inbox', [ id ]);
                }
                else if(el.classList.contains('deletefinally')) {
                    this.deleteFinally([ id ]);
                }
            });
        });

        // Upgrade-Links
        const btnsUpgrade = document.querySelectorAll('main a.upgrade');
        btnsUpgrade.forEach($btn => {
            $btn.addEventListener('click', event => {
                event.preventDefault();
                const $ele = event.currentTarget;
                const upgradetype = $ele.dataset.upgradetype ?? '';

                Upgrademodal.open(
                    () => {

                        // Seite neu laden
                        window.location.reload();
                    },
                    upgradetype
                );
            });
        });

    }

    displayMenuActions() {
        const currentBox = this.$submissionView.dataset.box;
        this.menuActions.forEach(el => {
            if(el.classList.contains('isspam')) {
                if(currentBox == "inbox")
                    el.classList.remove('hidden');
                else
                    el.classList.add('hidden');
            }
            else if(el.classList.contains('nospam')) {
                if(currentBox == "spam")
                    el.classList.remove('hidden');
                else
                    el.classList.add('hidden');
            }
            else if(el.classList.contains('delete')) {
                if(currentBox == "inbox")
                    el.classList.remove('hidden');
                else
                    el.classList.add('hidden');
            }
            else if(el.classList.contains('undelete')) {
                if(currentBox == "trash")
                    el.classList.remove('hidden');
                else
                    el.classList.add('hidden');
            }
            else if(el.classList.contains('deletefinally')) {
                if(currentBox == "trash")
                    el.classList.remove('hidden');
                else
                    el.classList.add('hidden');
            }
        });
    }

    moveTo(toBox, ids) {
        var data = new FormData();
        data.append("form_code", this.form_code);
        data.append("box", toBox);
        data.append("sub_ids", ids.join());

        // Meldungen ausblenden
        new Notification().hideAll();

        // Senden
        new Fetch().post(App.getUrl('form', 'submissions_move'), data)
        .then(response => {

            // Erfolgsmeldung
            new Notification().success(response.msg);

            // Box übernehmen
            this.$submissionView.dataset.box = toBox;
            this.displayMenuActions();
        })
        .catch(error => {

            // Fehlermeldung anzeigen
            new Notification().error('Error', error.message);
        });
    }

    deleteFinally(ids) {
        var data = new FormData();
        data.append("sub_ids", ids.join());

        // Meldungen ausblenden
        new Notification().hideAll();

        // Senden
        new Fetch().post(App.getUrl('form', 'submissions_deletefinally'), data)
        .then(response => {

            // Erfolgsmeldung
            new Notification().success(response.msg);

            // nach 1 Sek. zur Sendungsliste
            setTimeout(() => {
                App.goto('form', 'submissions', this.form_code);
            }, 1000);
        })
        .catch(error => {

            // Fehlermeldung anzeigen
            new Notification().error('Error', error.message);
        });
    }
}

// Initialisierung wenn DOM geladen
App.domready(() => {
    if(document.querySelector('body').classList.contains('form-submission')) {
        new Page();
    }
});